module.exports = __webpack_public_path__ + "static/media/perk-background.67c3be8f.svg";